<template>
  <div class="ba-w-100 ba-grid ba-gp-1 ">
    <template v-if="website && website.layouts && website.layouts.length > 0">
      <div v-if="website && website.layouts.length > 0" class="ba-w-100">
        <div class='ba-card ba-w-100'>
          <div class='ba-flex ba-w-100 ba-ai-center ba-jc-sb'>
            <span class='ba-title'>{{ $t('ct-my-pages') }}</span>
            <div class='ba-box-items ba-flex ba-gp-1'>
              <SearchInput :config="filters" @search="filterRestrictArea" />
              <button class="ba-btn ba-md ba-green" v-if="website.status === 'inactive'" @click.prevent="publish">
                {{ $t('ct-publish') }}
              </button>
              <button class="ba-btn ba-md ba-red" v-show="website.status === 'active'" @click.prevent="unpublish()">
                {{ $t('ct-unpublish') }}
              </button>
              <button class="ba-btn ba-md ba-green" v-if="website.status === 'active'" :disabled="!showRepublish"
                @click.prevent="republishAction()">
                {{ $t('ct-republish') }}
              </button>
            </div>
          </div>
          <hr class="ba-hr-row">
          <div class='ba-content ba-grid ba-gp-1 ba-w-100'>
            <div class="ba-flex ba-jc-sb ba-ai-center">
              <div class="ba-flex ba-ai-center ba-gp-1">
                <button data-ba-i="create-page" class="ba-btn ba-md ba-blue" v-show="website" aria-expanded="false"
                  aria-haspopup="true" data-toggle="dropdown">
                  <builderall-icon code='2780'></builderall-icon>
                  <span style="white-space: nowrap">{{ $t('ct-page-create') }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button class="dropdown-item" @click="newPage">
                    {{ $t('ct-new-page') }}
                  </button>
                  <button class="dropdown-item" @click="newPageTurbo">
                    {{ $t('ct-new-page-turbo') }}
                  </button>
                </div>
                <button :disabled="isDisabledCreateMemberArea && restrictAreas.length >= 30"
                  class="ba-btn ba-md ba-color-blue1" @click.prevent="newRestrictArea()">
                  <builderall-icon code='2780'></builderall-icon>
                  {{ $t("ct-restrict-area") }}
                </button>
                <div class="ba-flex ba-gp-1 ba-ai-center">
                  <button v-if="selectPages.type === 'all' || selectPages.selectedPages.length > 0"
                    class='ba-btn ba-btn-trash ba-sm ba-rounded' @click="deletedWebsites">
                    <builderall-icon code='trash' />
                  </button>
                  <div class="form-check pl-0 pr-2 builder-action-multiple-websites_checkbox-all">
                    <input id="select-websites-all" ref="select-all-websites" :checked="selectPages.type === 'all'"
                      type="checkbox" class="mr-2" @change.prevent="selectedPagesAll">

                    <label class="builder-action-multiple-websites_checkbox-all-label" for="select-websites-all">{{
                      $t('ct-websites-selected-all') }}</label>
                  </div>
                </div>
              </div>
              <div class="ba-flex ba-ai-center">
                <div class="ba-flex ba-ai-center ba-gp-02 choose-view">
                  <div v-if="!reordering" @click="ordenar()">
                    <builderall-icon code='e2a2'></builderall-icon>
                  </div>
                  <div v-if="reordering" @click="salvarOrdem()">
                    <builderall-icon code='3791' :class="{ 'ba-color-green1': reordering }"></builderall-icon>
                  </div>
                  <div :class="{ 'selected': typeView === 'card' }" @click="typeView = 'card'">
                    <!-- <i class="ct-icon-dash-card" /> -->
                    <builderall-icon code='1af6'></builderall-icon>
                  </div>
                  <div :class="{ 'selected': typeView === 'list' }" @click="typeView = 'list'">
                    <!-- <i class="ct-icon-dash-list" /> -->
                    <builderall-icon code='65da'></builderall-icon>
                  </div>
                </div>
              </div>
            </div>

            <div id="pages" class="" :class="{ 'container-box': typeView === 'card' }">
              <site-page-card v-for="(page) in pagesFiltered" :key="page.id" :page="page" :website="website"
                :reordering="reordering" :type_view="typeView" :select-pages="selectPages" :isUnpublish="isUnpublish"
                @goToWebsitePage="goToWebsitePage" @confirmDelete="confirmDelete" @uploadImagePage="uploadImagePage" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="
        website.layouts &&
        website.layouts[0].pages.filter((p) => p.is_blog).length > 0
      " class="blog-container-block">
        <hr class="px-2">

        <div class="d-flex align-items-center pt-5">
          <span class="title-member-area d-inline-block">{{
            $t("ct-blog-pages")
            }}</span>
        </div>
        <div class="blog-block-list-pages pb-4">
          <site-page-card v-for="(page, index) in website.layouts[0].pages.filter(
            (p) => p.is_blog
          )" :key="index" :page="page" :website="website" @goToWebsitePage="goToWebsitePage"
            @confirmDelete="confirmDelete" @uploadImagePage="uploadImagePage" />
        </div>
      </div>

      <template v-if="restrictAreas.length > 0">
        <div class='ba-card ba-w-100'>
          <div class='ba-top ba-flex'>
            <span class='ba-title'>{{ $t("ct-restrict-areas") }}</span>
            <div class="choose-view ba-box-items ba-flex ba-ai-center ba-gp-02">
              <div :class="{ 'selected': viewRestrict === 'inline' }" @click="changeViewRestrict">
                <builderall-icon code='1af6'></builderall-icon>
              </div>
              <div :class="{ 'selected': viewRestrict === 'block' }" @click="changeViewRestrict">
                <builderall-icon code='65da'></builderall-icon>
              </div>
            </div>
          </div>
          <div class='ba-content ba-grid ba-gp-1 ba-w-100'>
            <div :class="{ 'container-box': viewRestrict === 'inline' }">
              <template v-if="this.viewRestrict === 'block'">
                <div v-for="(restrict, index) of this.restrictAreasFormat" :key="index">
                  <div class="box-restrict-header">
                    <div class="d-inline-flex align-items-center d-block-sm pr-2">
                      <div :style="{
                        'background-color': restrict.color,
                        position: 'relative',
                        top: 'auto',
                        left: 'auto',
                      }" class="box-icon-left-sm" />
                    </div>
                    <div class="box-restrict-image-container"
                      :style="`background-image: url('/static/images/cheetah-og.png')`">
                    </div>
                    <span class="title-principal px-2">{{ restrict.name }} </span>
                    <div class="ba-flex ba-gp-1 ml-auto">
                      <button class='ba-btn ba-btn-normal ba-sm ba-rounded' ba-tooltip-position='right'
                        :ba-tooltip-title="$t('ct-edit')" @click="editRestrictArea(restrict)">
                        <builderall-icon code='edit' />
                      </button>
                      <button v-show="!restrict.is_blog" class='ba-btn ba-btn-trash ba-sm ba-rounded'
                        ba-tooltip-position='right' :ba-tooltip-title="$t('ct-delete')" @click.prevent="
                          confirmDelete('restrict', {
                            restrict: restrict,
                            index: index,
                          })
                          ">
                        <builderall-icon code='trash' />
                      </button>
                    </div>
                  </div>
                  <div v-if="restrict.pagesObj" class="restrict-area-container-block-list-pages">
                    <site-page-card v-for="(page, index) in restrict.pagesObj" :key="index" :page="page"
                      :website="website" @goToWebsitePage="goToWebsitePage" @confirmDelete="confirmDelete"
                      @uploadImagePage="uploadImagePage" />
                  </div>
                </div>
              </template>

              <template v-else>
                <div v-for="(restrict, index) of this.restrictAreasFormat" :key="index" class="card-restrict">
                  <div class="card-restrict-body">
                    <div class="card-body-image-container"
                      :style="`background-image: url('/static/images/cheetah-og.png')`">
                      <div class="ba-flex ba-w-100 ba-ai-center ba-jc-fe p-3">
                        <div :style="{'background-color': restrict.color}" class="box-icon-left-sm">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-restrict-footer">
                    <div class="box-info">
                      <span class="title-principal">{{ restrict.name }} </span>
                    </div>
                    <div class="box-options">
                      <div class="ba-flex ba-gp-1">
                        <button class='ba-btn ba-btn-normal ba-sm ba-rounded' ba-tooltip-position='right'
                          :ba-tooltip-title="$t('ct-edit')" @click="editRestrictArea(restrict)">
                          <builderall-icon code='edit' />
                        </button>
                        <button v-show="!restrict.is_blog" class='ba-btn ba-btn-trash ba-sm ba-rounded'
                          ba-tooltip-position='right' :ba-tooltip-title="$t('ct-delete')" @click.prevent="
                            confirmDelete('restrict', {
                              restrict: restrict,
                              index: index,
                            })
                            ">
                          <builderall-icon code='trash' />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>

      <modal-component ref="restrictArea" header="true">
        <div slot="header" class="ba-w-100">
          <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
            <h5 class="ba-color-blue1">{{ $t(`ct-restrict-area-${restrictArea.controller}-title`) }}</h5>
            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click.prevent="cancelRestrictArea">
              <builderall-icon code='64f7' />
            </button>
          </div>
          <hr class='ba-hr-row'>
        </div>

        <div slot="body" class="ba-w-100">
          <form class="ba-grid ba-gp-1">
            <div class="ba-flex ba-w-100 ba-ai-end ba-gp-1">
              <div class="ba-box-input ba-w-75">
                <label for="name" class="ba-custom-label">{{ $t("ct-name") }}</label>
                <input id="name" v-model="restrictArea.name" :placeholder="$t('ct-name')"
                  :class="{ ' ba-error': errors.has('restrictArea.name') }" :disabled="!its_not_blog" type="text"
                  name="name" class="ba-input ba-md" minlength="3" maxlength="120" required
                  @keydown="errors.clear('restrictArea.name')">
                <span v-if="errors.has('restrictArea.name')" class="ba-validation-text"
                  v-text="errors.get('restrictArea.name')" />
              </div>
              <div class="ba-grid" v-if="its_not_blog">
                <div class="ba-flex ba-w-100 ba-ai-center ba-gp-06">
                  <input id="color" v-model="restrictArea.color"
                    :class="{ 'is-invalid': errors.has('restrictArea.color') }" type="color" name="color"
                    value="#FFFFFF" required @click="errors.clear('restrictArea.color')">
                  <!-- <span :style="'background-color:' + restrictArea.color" class="selected-color" onclick="$('#color').click()"></span> -->
                  <span class="ba-custom-label">{{ $t("ct-select-color") }}</span>
                </div>
                <span v-if="errors.has('restrictArea.color')" class="invalid-feedback"
                  v-text="errors.get('restrictArea.color')"></span>
              </div>
            </div>

            <div class="ba-w-100 ba-box-input">
              <label for="description" class="ba-custom-label">{{ $t("ct-description") }}</label>
              <input id="description" v-model="restrictArea.description" :placeholder="$t('ct-description')" :class="{
                'ba-error': errors.has('restrictArea.description'),
              }" value="Description" class="ba-textarea" maxlength="220" rows='5' cols='30'
                @keydown="errors.clear('restrictArea.description')">
              <span v-if="errors.has('restrictArea.description')" class="ba-validation-text"
                v-text="errors.get('restrictArea.description')" />
            </div>

            <div v-if="this.restrictAreaTypes && its_not_blog" class="">
              <span>{{ $t("ct-restrict-area-access-release") }}</span>
              <div v-for="(type, index) in this.restrictAreaTypes" :key="index" class="ba-form-check">
                <input :id="`restrict-area-type-${type.key}`" :value="type.id"
                  :checked="parseInt(restrictArea.type) === parseInt(type.id)" v-model="restrictArea.type"
                  :class="{ 'is-invalid': errors.has('restrictArea.type') }" type="radio" name="type" required @change="
                    [
                      errors.clear('restrictArea.type'),
                      (restrictArea.elearning_course_id = '0'),
                      (restrictArea.elearning_course_secret = null),
                    ]
                    ">
                <label :for="`restrict-area-type-${type.key}`" v-html="$t(`ct-${type.key}`)" />
              </div>
              <span :class="{ 'd-inline': errors.has('restrictArea.type') }" class="invalid-feedback"
                v-text="errors.get('restrictArea.type')" />
            </div>

            <div v-if="this.auth_types && its_not_blog && ![4, 5].includes(restrictArea.type)">
              <span>{{ $t("ct-restrict-area-auth-type") }}</span>
              <div v-for="(auth_type, index) in this.auth_types" :key="index" class="ba-form-radio">
                <input :id="`restrict-area-auth-type-${auth_type}`" :value="auth_type" v-model="restrictArea.auth_type"
                  :class="{
                    'is-invalid': errors.has('restrictArea.auth_type'),
                  }" type="radio" name="auth-type" required @change="errors.clear('restrictArea.auth_type')">
                <label :for="`restrict-area-auth-type-${auth_type}`">{{ $t(`ct-auth-type-${auth_type}`) }}</label>
              </div>
              <span :class="{ 'd-inline': errors.has('restrictArea.auth_type') }" class="invalid-feedback"
                v-text="errors.get('restrictArea.auth_type')" />
            </div>

            <!-- tokens -->
            <div v-if="restrictArea.auth_type === 'both' || restrictArea.auth_type === 'token'"
              class="ba-grid ba-gp-08">
              <div class="ba-flex ba-jc-sb">
                <span>{{ $t("ct-restrict-area-tokens") }}</span>
                <button class="ba-btn ba-md ba-blue" @click.prevent="addNewToken">
                  <builderall-icon code='2780' />
                  {{ $t("ct-add-token") }}
                </button>
              </div>

              <div class="ba-w-100 ba-grid ba-gp-08">
                <!-- <p class="text-restrict-form">{{ $t("ct-my-tokens") }}</p> -->
                <div class='ba-card ba-w-100 ba-blue ba-no-shadow' v-for="(token, index) in restrictArea.tokens"
                  v-if="restrictArea.tokens.length > 0">
                  <div class="ba-flex ba-w-100 ba-ai-center ba-jc-sb">
                    <div>{{ index + 1 }}</div>
                    <hr class='ba-hr-column'>
                    <div style="width: 250px;">
                      {{ token.token }}
                      <input :id="`copy-token-${index}`" :value="token.token" type="hidden">
                    </div>
                    <hr class='ba-hr-column'>
                    <div class="ba-flex ba-gp-08 ba-jc-fe ba-ai-center" style="width: 120px;">
                      <button v-if="token.type === 'custom'" class='ba-btn ba-btn-normal ba-sm ba-rounded'
                        @click.prevent="editToken(token)" ba-tooltip-position='right' :ba-tooltip-title="$t('ct-edit')">
                        <builderall-icon code='edit' />
                      </button>
                      <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="copyToken(index)"
                        ba-tooltip-position='right' :ba-tooltip-title="$t('ct-copy')">
                        <builderall-icon code='b54c'></builderall-icon>
                      </button>
                      <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="deleteToken(token, index)"
                        ba-tooltip-position='right' :ba-tooltip-title="$t('ct-delete-field')">
                        <builderall-icon code='trash' />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- pages -->
            <div v-if="website && website.layouts && website.layouts[0].pages && its_not_blog">
              <span>{{ $t("ct-pages") }}</span>
              <div class="ba-w-100 ba-flex ba-gp-08 ba-f-wrap">
                <div v-for="(page, index) in website.layouts[0].pages.filter(
                  (p) => !p.is_blog && !p.is_member && !p.is_turbo
                )" :key="index">
                  <div class="ba-form-check">
                    <input :value="page.id" :id="`page-${page.id}`" v-model="restrictArea.pages" type="checkbox">
                    <label :for="`page-${page.id}`">{{ page.name }}</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- member`s area main page -->
            <div v-if="its_not_blog" class="ba-w-100">
              <span class="ba-custom-label">{{ $t("ct-members-page-home") }}</span>
              <div class="ba-grid ba-w-100">
                <div
                  v-if="!parseInt(restrictArea.elearning_course_id) || restrictArea.redirect_config.elearning.type === 'normally-page'"
                  class="ba-grid">
                  <select id="home-page-id" v-model="restrictArea.home_page_id" :class="{
                    'is-invalid': errors.has('restrictArea.home_page_id'),
                  }" class="ba-select ba-md" name="home-page-id" @change="errors.clear('restrictArea.home_page_id')">
                    <option value="0">
                      {{ $t("ct-members-selected-page-home") }}
                    </option>
                    <option v-for="(page, index) in website.layouts[0].pages.filter(
                      (p) => !p.is_blog && !p.is_member && !p.is_turbo
                    )" :key="index" :value="page.id">
                      {{ page.name }}
                    </option>
                  </select>
                  <small class="ba-color-black18">{{ $t("ct-members-page-home-help") }}</small>
                </div>
                <div v-else class="ba-w-100">
                  <p>{{ $t("ct-members-page-home-elearning-help") }}</p>
                </div>
              </div>
            </div>

            <div id="restrict-area-accordion" class="container-accordion-form ba-grid ba-gp-08">
              <!-- Elearning -->
              <div v-if="its_not_blog && ![4, 5].includes(restrictArea.type) && restrictArea.auth_type === 'register'"
                class="card ba-w-100">
                <div id="elearningSettings" class="card-header">
                  <span class="py-1 d-flex align-items-center justify-content-between collapsed" data-toggle="collapse"
                    data-target="#collapseElearning" aria-expanded="false" aria-controls="collapseElearning">{{
                    $t("ct-elearning") }}
                    <div v-if="loading.elearning" class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <font-awesome-icon v-else :icon="['fas', 'chevron-down']" class="font-awesome-icon" />
                  </span>
                </div>
                <div id="collapseElearning" class="collapse" aria-labelledby="elearningSettings"
                  data-parent="#restrict-area-accordion">
                  <div v-if="!loading.elearning" class="card-body ba-grid ba-gp-1">
                    <div class="ba-grid" v-if="elearningCourses && elearningCourses.length > 0">
                      <label class="ba-custom-label">{{ $t("ct-members-choose-course") }}</label>
                      <select id="elearning-course" v-model="restrictArea.elearning_course_id" :class="{
                          'is-invalid': errors.has(
                            'restrictArea.elearning_course_id'
                          ),
                        }" class="ba-select" name="elearning-course" @change="
                          errors.clear('restrictArea.elearning_course_id')
                          ">
                        <option value="0">
                          {{ $t("ct-members-selected-course") }}
                        </option>
                        <option v-for="(course, index) in elearningCourses" :key="index" :value="course.id">
                          {{ course.name }}
                        </option>
                      </select>
                    </div>
                    <template v-else>
                      <p>{{ $t("ct-elearning-courses-empty") }}</p>
                    </template>

                    <template v-if="restrictArea.elearning_course_id && restrictArea.elearning_course_id !== '0'">
                      <div v-if="elearningCourses && elearningCourses.length > 0" class="ba-grid">
                        <span class="ba-custom-label">{{ $t("ct-elearning-redirect") }}</span>
                        <div class="ba-grid">
                          <div class="ba-form-radio">
                            <input id="redirect-normally" v-model="restrictArea.redirect_config.elearning.type"
                              type="radio" name="redirect-config" value="normally-page">
                            <label for="redirect-normally">{{ $t("ct-redirect-page-normally") }}</label>
                          </div>
                          <div class="ba-form-radio">
                            <input id="redirect-course" v-model="restrictArea.redirect_config.elearning.type"
                              type="radio" name="redirect-config" value="elearning-course">
                            <label for="redirect-course">{{ $t("ct-redirect-elearning-course") }}</label>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if=" elearningCourses && elearningCourses.length > 0 && restrictArea.redirect_config.elearning.type && restrictArea.redirect_config.elearning.type === 'elearning-course' "
                        class="ba-grid">
                        <label class="ba-custom-label">{{ $t("ct-members-elearning-target") }}</label>
                        <div class="ba-grid">
                          <div class="ba-form-radio">
                            <input id="redirect-target-same" v-model="restrictArea.redirect_config.elearning.target"
                              type="radio" name="redirect-target" value="same">
                            <label for="redirect-target-same">{{ $t("ct-redirect-target-same") }}</label>
                          </div>
                          <div class="ba-form-radio">
                            <input id="redirect-target-blank" v-model="restrictArea.redirect_config.elearning.target"
                              type="radio" name="redirect-target" value="blank">
                            <label for="redirect-target-blank">{{ $t("ct-redirect-target-blank") }}</label>
                          </div>
                        </div>
                      </div>

                      <div v-if="elearningCourses && elearningCourses.length > 0" class="ba-grid ba-w-100">
                        <label class="ba-custom-label" for="elearning-redirect-logout">{{
                          $t("ct-members-elearning-logout-page") }}</label>
                        <select id="elearning-redirect-logout"
                          v-model="restrictArea.redirect_config.elearning.logout_redirect"
                          name="elearning-redirect-logout" class="ba-select">
                          <option value="0" selected>
                            {{ $t("ct-choose-elearning-redirection-logout") }}
                          </option>
                          <option v-for="page in pagesFiltered" :value="page.id">
                            {{ page.name }}
                          </option>
                        </select>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <!-- Mailingboss -->
              <div class="card mb-4">
                <div id="mailingbossSettings" class="card-header">
                  <span class="py-1 d-flex align-items-center justify-content-between collapsed" data-toggle="collapse"
                    data-target="#collapseMailingboss" aria-expanded="false" aria-controls="collapseMailingboss">{{
                    $t("ct-mailing-boss") }}
                    <div v-if="loading.mailingboss" class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <font-awesome-icon v-else :icon="['fas', 'chevron-down']" class="font-awesome-icon" />
                  </span>
                </div>
                <div id="collapseMailingboss" class="collapse" aria-labelledby="mailingbossSettings"
                  data-parent="#restrict-area-accordion">
                  <div v-if="!loading.mailingboss" class="card-body">
                    <div class="ba-grid ba-gp-06">
                      <div class="ba-grid">
                        <label for="list-integracao-mb" class="ba-custom-label">{{ $t("ct-mailing-boss-list") }}</label>
                        <select id="list-integracao-mb" v-model="restrictArea.mailingboss_list_id" class="ba-select"
                          name="list-integracao-mb">
                          <option value="0">
                            {{ $t("ct-mailing-boss-list-select") }}
                          </option>
                          <option v-for="(mb_list, index) in mailingboss_lists" :key="index"
                            :value="mb_list.general.list_uid">
                            {{ mb_list.general.name }}
                          </option>
                        </select>
                      </div>
                      <div class='ba-require-alert ba-warning'>
                        <div class='ba-pbutton'>
                          <span>{{ $t("ct-warning") }}!</span>
                          <p>{{ $t("ct-restrict-mb-list-warning") }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div slot="footer" class="ba-w-100 ba-ai-center ba-flex ba-gp-1 ba-jc-fe">
          <button class="ba-btn ba-md ba-light" @click.prevent="cancelRestrictArea">
            {{ $t("ct-cancel") }}
          </button>
          <button class="ba-btn ba-md ba-blue" @click.prevent="saveRestrictArea">
            {{ $t("ct-save") }}
          </button>
        </div>
      </modal-component>

      <modal-component ref="restrictArea-token-add" header="true">
        <div slot="header" class="ba-w-100">
          <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
            <h5 class="ba-color-blue1">{{ $t(`ct-restrict-area-my-tokens`) }} - {{ $t(`ct-${newToken.action}`) }}</h5>
            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click.prevent="closeNewToken">
              <builderall-icon code='64f7' />
            </button>
          </div>
          <hr class='ba-hr-row'>
        </div>

        <div slot="body" class="ba-w-100">
          <form>
            <div class="ba-grid ba-gp-08">
              <div v-if="this.auth_types && newToken.action !== 'edit'" class="ba-grid ba-gp-08">
                <span class="ba-custom-label">{{ $t("ct-restrict-area-auth-type") }}</span>

                <div class="ba-grid">
                  <div class="ba-form-radio">
                    <input id="restrict-area-token-type-random" v-model="newToken.type"
                      :class="{ 'is-invalid': errors.has('newToken.type') }" type="radio" name="token-type"
                      value="random" required @change="errors.clear('newToken')">

                    <label for="restrict-area-token-type-random">
                      {{ $t(`ct-token-type-random`) }}
                    </label>
                  </div>

                  <div class="ba-form-radio">
                    <input id="restrict-area-token-type-custom" v-model="newToken.type"
                      :class="{ 'is-invalid': errors.has('newToken.type') }" type="radio" name="token-type"
                      value="custom" required @change="errors.clear('newToken')">

                    <label for="restrict-area-token-type-custom">
                      {{ $t(`ct-token-type-custom`) }}
                    </label>
                  </div>
                </div>

                <span :class="{ 'd-inline': errors.has('newToken.type') }" class="invalid-feedback"
                  v-text="errors.get('newToken.type')" />
              </div>

              <div v-if="newToken.type === 'custom' || newToken.action === 'edit'" class="ba-grid">
                <label for="token-value" class="ba-custom-label">{{
                  $t("ct-token-value")
                  }}</label>
                <div class="ba-box-input">
                  <input id="token-value" v-model="newToken.token" :placeholder="$t('ct-token-value')"
                    :class="{ 'ba-error': errors.has('newToken.token') }" :disabled="newToken.type === 'random'"
                    type="text" name="token-value" class="ba-input ba-md" minlength="5" maxlength="40" required
                    @keydown="errors.clear('newToken.token')">
                  <span v-if="errors.has('newToken.token')" class="ba-validation-text"
                    v-text="errors.get('newToken.token')" />
                </div>
              </div>
            </div>
          </form>
        </div>

        <div slot="footer" class="ba-w-100 ba-flex ba-ai-center ba-jc-fe ba-gp-1">
          <button class="ba-btn ba-md ba-light" @click.prevent="closeNewToken">
            {{ $t("ct-cancel") }}
          </button>
          <button class="ba-btn ba-md ba-blue" @click.prevent="saveNewToken">
            {{ $t("ct-save") }}
          </button>
        </div>
      </modal-component>

      <modal-component ref="restrictArea-tokens" header="true" min-width="300px" width="40%">
        <span slot="header" class="title-modal-member">{{
          $t(`ct-restrict-area-my-tokens`)
          }}</span>

        <div slot="body" class="w-100" style="margin: 0 50px">
          <div class="row">
            <table class="table col-12">
              <tbody>
                <tr v-for="(token, index) in restrictArea.tokens">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ token.token }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <button slot="footer" class="btn btn-dark" style="position: absolute; left: 0; margin: 0 1.25rem"
          @click.prevent="addNewToken">
          Add token
        </button>

        <button slot="footer" class="btn" @click.prevent="">
          {{ $t("ct-cancel") }}
        </button>

        <button slot="footer" class="btn btn-success text-uppercase" @click.prevent="">
          <i class="svg-icon svgi-save" />{{ $t("ct-save") }}
        </button>
      </modal-component>

      <sweet-modal ref="restrictAreaAddPage">
        <section>
          <h1 class="mt-4">{{ $t("ct-page-members") }}</h1>
          <h2 class="mt-4">{{ $t("ct-page-members-description") }}</h2>
        </section>
        <button slot="button" class="btn btn-outline-light" @click.prevent="$refs.restrictAreaAddPage.close()">
          {{ $t("ct-cancel") }}
        </button>
        <button slot="button" class="btn btn-success" @click.prevent="saveNewPageMembers">
          {{ $t("ct-save") }}
        </button>
      </sweet-modal>

      <modal-delete-component :show="modalDelete.page.show" :title="modalDelete.page.text"
        :text="modalDelete.page.description" :values="modalDelete.page.config" @cancel="cancelModal('page')"
        @exclude="deletePage" />

      <modal-delete-component :show="modalDelete.restrict.show" :values="modalDelete.restrict.config"
        @cancel="cancelModal('restrict')" @exclude="deleteRestrictArea" />

      <!-- MODAL DELETE SELECT WEBSITES   -->
      <sweet-modal ref="confirmDeleteSelectedWebsites" width="496px" hide-close-button
        class="modal-confirm-deleted-websites" blocking>
        <alert-box-new-component :with_icon="true" type="danger">
          <span slot="content">{{ $t('ct-modal-deleted-attention') }}</span>
        </alert-box-new-component>

        <p v-if="selectPages.selectedPages.length === 1">{{ $t('ct-modal-deleted-page-description') }}</p>
        <p v-else>{{ $t('ct-modal-deleted-pages-description') }}</p>

        <button slot="button" class="btn btn-outline-light"
          @click.prevent="$refs.confirmDeleteSelectedWebsites.close()">{{
          $t('ct-cancel') }}
        </button>
        <button slot="button" class="btn btn-danger" @click.prevent="confirmDeletedPages">{{ $t('ct-delete') }}
        </button>
      </sweet-modal>
    </template>
  </div>
</template>

<script>
import Errors from "../../../js/base/Errors";
import { mapGetters } from "vuex";
import Sortable from "sortablejs";
import {
  createMembers,
  duplicate as duplicatePage,
  editConfiguration as editConfigurationPage,
  exclude as excludePage,
  reorderPages,
  deletedPagesSelected
} from "../../../js/services/editor/page";
import {
  create as createRestrictArea,
  edit as editRestrictArea,
  exclude as excludeRestrictArea,
  getAll as getAllRestrictArea,
  getTypes as getRestrictAreaTypes,
} from "../../../js/services/restrictArea/restrictArea";
import {
  get as getWebsite,
  updateStatus
} from "../../../js/services/editor/website";
import { getCourses as getElearningCourses } from "../../../js/services/integrations-internas/elearming";
import { getLists } from "../../../js/services/integrations-internas/mailingboss";

import ModalDeleteComponent from "./../components/ModalDelete";
import ModalComponent from "./../../general/Modal";
import { SweetModal } from "sweet-modal-vue";
import SitePageCard from "../layout/site/SitePageCard";
import AlertBoxNewComponent from "../../commons/AlertBoxNewComponent.vue";
import SearchInput from "../../general/SearchInput.vue";

export default {
  name: "WebsiteHomeVue",
  props: ['showRepublish'],
  components: {
    AlertBoxNewComponent,
    SitePageCard,
    ModalComponent,
    ModalDeleteComponent,
    SweetModal,
    SearchInput
  },
  data() {
    return {
      loading: {
        mailingboss: false,
        elearning: false,
      },
      typeView: 'card',
      selectPages: {
        type: 'unitary', // unitary or all
        selectedPages: [],
        total: 0
      },
      steps: [],
      stepsOptions: {
        useKeyboardNavigation: false,
        highlight: true,
        labels: {},
      },
      offsetScroll: 0,
      tour: {
        currentStep: 0,
      },

      sortable: null,
      reordering: false,
      website: {},
      copy_success: false,
      pagesFiltered: {},
      viewRestrict: "inline",
      errors: new Errors(),
      mailingboss_lists: [],
      filters: {
        restrict: {},
        search: "",
      },
      elearningCourses: {},
      restrictAreas: {},
      restrictAreasFormat: {},
      restrictAreaTypes: {},
      auth_types: ["token", "register", "both"],
      time_zones: {},
      newToken: {
        action: "create",
        time_zone_id: "",
        token: "",
        type: "random",
        expires_at: "",
        has_expires_at: 0,
      },
      restrictArea: {
        controller: "create",
        name: "",
        description: "",
        color: "#FFFFFF",
        type: "",
        auth_type: "",
        pages: [],
        mailingboss_list_id: "0",
        tokens: [],
        elearning_course_id: "0",
        elearning_course_secret: null,
        home_page_id: "0",
        redirect_config: {
          elearning: {
            type: "normally-page", // elearning-courso,
            target: "same",
            logout_redirect: "0",
          },
        },
      },
      imagePage: {
        show: false,
        page: "",
      },
      itemsConfig: {
        show: false,
        layout: "",
      },
      modalDelete: {
        website: {
          text: this.$t("ct-confirm-delete-website"), // 'Do you really want to delete this website?',
          // description: 'Deletara todas as infos',
          show: false,
          config: "",
        },
        page: {
          text: this.$t("ct-confirm-delete-page"), // 'Do you really want to delete this page?',
          show: false,
          config: "",
          hideConfirm: false,
        },

        publish: {
          show: false,
          config: false,
        },
        saveTour: {
          show: false,
          config: false,
          type: "save",
        },

        restrict: { show: false, config: "" },
      },
      sidebarMini: false,
    };
  },

  computed: {
    websiteCurrent() {
      return this.$store.getters.website;
    },
    its_not_blog() {
      return !this.restrictArea.is_blog;
    },
    isDisabledCreateMemberArea() {
      const user = this.$store.getters.user;
      return user ? new Date(user.created_at) >= new Date("2023-01-01") : false;
    },

    isUnpublish() {
      return this.website.status !== 'active';
    },
  },

  watch: {
    websiteCurrent: {
      handler: function (val, oldVal) {
        if (Object.keys(val).length > 0)
          this.setWebsite(val);

      },
      deep: true,
    },
    website: {
      handler: async function (val, oldVal) {
        if (Object.keys(val).length > 0) {
          await this.updateFormatRestrictPage();
          await this.filterRestrictArea();
        }
      },
      deep: true,
    },

    "restrictArea.elearning_course_id": function (value) {
      if (value && this.elearningCourses.length > 0) {
        let course = this.elearningCourses.find(
          (course) => parseInt(course.id) === parseInt(value)
        );

        if (course)
          this.restrictArea.elearning_course_secret = course.secret;

      }
    },

    'typeView': function () {
      localStorage.setItem('pages-type-view', this.typeView);
    }
  },
  methods: {
    ...mapGetters({ getUser: "user" }),
    newPage() {
      if (this.$route.name !== 'SitePageCreate') {

        this.$router.push({ name: 'SitePageCreate', params: { layout_id: this.websiteCurrent.layouts[0].encrypted_id } });
      }
    },
    republishAction() {
      this.$emit('republish');
    },

    publish() {
      this.$emit('publish');
    },

    unpublish(status = 'inactive') {
      let data = {
        encrypted_id: this.$parent.website.encrypted_id,
        status: status
      };

      this.updateStatus(data);
    },
    updateStatus(data) {
      updateStatus(data)
        .then(res => {
          this.$emit('changeStatusPublish', data.status);
        })
        .catch(error => {
          console.error(error);
          this.$snotify.error(
            'Something happened when trying to unpublish or publish your site, check the settings'
          );
        });
    },
    typeViewLoad() {
      if (localStorage.getItem('pages-type-view') !== null)
        this.typeView = localStorage.getItem('pages-type-view');
    },

    deletedWebsites() {
      this.$refs.confirmDeleteSelectedWebsites.open();
    },

    confirmDeletedPages() {
      deletedPagesSelected(this.website.id, this.selectPages)
        .then(() => {
          this.$store.commit("website", false);
          this.$refs.confirmDeleteSelectedWebsites.close();
          this.clearSelect();
        })
        .catch(error => console.warn(error));
    },

    selectedPagesAll() {
      this.selectPages.type = this.selectPages.type === 'all' ? 'unitary' : 'all';
      this.$refs['select-all-websites'].checked = true;
    },

    checkedSelectAll(userEmail) {
      if (this.selectPages.type === 'all') {
        this.selectPages.type = 'unitary';
        this.$refs['select-all-websites'].checked = false;
      }

      if (!this.selectPages.selectedPages.includes(userEmail))
        this.selectPages.selectedPages.push(userEmail);

      this.changeUnitary();
    },

    changeUnitary() {
      this.selectPages.total = this.selectPages.selectedPages.length;
    },

    clearSelect() {
      this.selectPages = {
        type: 'unitary', // unitary or all
        selectedPages: [],
        total: 0
      };
    },

    setWebsite(website) {
      if (Object.keys(website).length === 0)
        return;


      this.website = { ...website };
    },

    ordenar() {
      this.reordering = true;
      var el = document.getElementById("pages");
      this.sortable = Sortable.create(el, {
        animation: 150,
        handle: ".drag",
      });
    },

    salvarOrdem() {
      this.$loading.show();
      this.reordering = false;
      var items = [];
      $("*[data-id]").each(function () {
        items.push($(this).data("id"));
      });

      reorderPages(items)
        .then(async () => {
          await this.updateData();
        })
        .finally(() => this.$loading.hide());
    },

    openSaveTour() {
      let website = this.website;

      this.modalDelete.saveTour.show = 1;
      this.website = Object.assign({}, website, {
        status: "active",
      });
      this.$store.commit("website", website);
    },

    newRestrictArea() {
      if (this.isDisabledCreateMemberArea && this.restrictAreas.length >= 30)
        return;

      this.fetchDataModal();
      this.restrictArea.controller = "create";
      this.restrictArea.website_id = this.website.id;
      this.$refs.restrictArea.open();
    },

    editRestrictArea(restrict) {
      this.fetchDataModal();
      restrict.redirect_config = restrict.redirect_config
        ? { ...this.restrictArea.redirect_config, ...restrict.redirect_config }
        : this.restrictArea.redirect_config;
      this.restrictArea = { ...this.restrictArea, ...restrict };
      this.restrictArea.controller = "update";
      this.restrictArea.type = restrict.type_id;
      this.restrictArea.website_id = this.website.id;
      this.restrictArea.elearning_course_id = restrict.elearning_course_id
        ? restrict.elearning_course_id
        : "0";
      this.restrictArea.home_page_id = restrict.home_page_id
        ? restrict.home_page_id
        : "0";
      this.restrictArea.mailingboss_list_id = restrict.mailingboss_list_id
        ? restrict.mailingboss_list_id
        : "0";
      this.$refs.restrictArea.open();
    },

    deleteRestrictArea({ restrict, index }) {
      this.$loading.show();

      restrict.website_id = this.website.id;

      excludeRestrictArea(restrict)
        .then((response) => {
          if (response.data.success) {
            this.restrictAreas.splice(index, 1);

            this.clearFilters();
            this.fetchRestrictArea();
          } else {
            this.$snotify.error(this.$t("ct-success-false"), {
              position: "centerTop",
            });
          }
        })
        .catch((error) => {
          this.$snotify.success(this.$t("ct-success-false"), {
            position: "centerTop",
          });
        })
        .finally(() => {
          this.cancelModal("restrict");
          this.$loading.hide();
        });
    },

    saveRestrictArea() {
      this.$loading.show();

      this.restrictArea = { ...this.restrictArea, website_id: this.website.id };

      if (this.restrictArea.controller === "update")
        this.updateRestrictArea();
      else
        this.createRestrictArea();

    },

    randomToken() {
      return Array(32)
        .fill(0)
        .map((x) => Math.random().toString(36).charAt(2))
        .join("");
    },

    validateNewToken() {
      this.newToken.token = this.newToken.token.trim();

      if (!this.newToken.type && !(this.newToken.type.length > 0))
        this.errors.add("type", "validation-required", "newToken");


      if (this.newToken.type === "custom") {
        if (!this.newToken.token && !(this.newToken.token.length > 0))
          this.errors.add("token", "validation-required", "newToken");


        if (this.newToken.token) {
          let tokenVerify = this.restrictArea.tokens.filter(
            (token) => token.token === this.newToken.token
          );
          if (tokenVerify.length > 0)
            this.errors.add("token", "already-been-taken", "newToken");

          this.newToken.token.trim();

          if (
            this.newToken.token.length > 0 &&
            this.newToken.token.length < 5
          ) {
            this.errors.add(
              "token",
              `${this.$t("ct-validation-must-be-at-least")} 5 ${this.$t(
                "ct-characters"
              )}`,
              "newToken",
              false
            );
          }

          if (
            this.newToken.token.length > 0 &&
            this.newToken.token.length > 40
          ) {
            this.errors.add(
              "token",
              `${this.$t("ct-validation-may-not-be-greater-than")} 40 ${this.$t(
                "ct-char"
              )}`,
              "newToken",
              false
            );
          }
        }
      }

      if (this.newToken.has_expires_at) {
        if (
          !this.newToken.time_zone_id &&
          !(this.newToken.time_zone_id.length > 0)
        )
          this.errors.add("time_zone_id", "validation-required", "newToken");


        if (
          !this.newToken.expires_at &&
          !(this.newToken.expires_at.length > 0)
        )
          this.errors.add("expires_at", "validation-required", "newToken");

      }

      return !this.errors.any();
    },

    saveNewToken() {
      if (this.newToken.action !== "edit") {
        if (this.validateNewToken()) {
          this.$refs["restrictArea-token-add"].close();

          if (this.newToken.type === "custom")
            this.restrictArea.tokens.push(this.newToken);
          else {
            this.newToken.token = this.randomToken();
            this.restrictArea.tokens.push(this.newToken);
          }

          this.newToken = {
            action: "create",
            time_zone_id: "",
            token: "",
            type: "random",
            expires_at: "",
            has_expires_at: 0,
          };
        }
      } else {
        if (this.validateNewToken()) {
          this.restrictArea.tokens.map((token, index) => {
            if (token.id === this.newToken.id)
              this.restrictArea.tokens[index] = this.newToken;
          });

          this.$refs["restrictArea-token-add"].close();

          this.newToken = {
            action: "create",
            time_zone_id: "",
            token: "",
            type: "random",
            expires_at: "",
            has_expires_at: 0,
          };
        }
      }
    },

    closeNewToken() {
      this.newToken = {
        action: "create",
        time_zone_id: "",
        token: "",
        type: "random",
        expires_at: "",
        has_expires_at: 0,
      };

      this.$refs["restrictArea-token-add"].close();
    },

    cancelRestrictArea() {
      this.restrictArea = {
        controller: "create",
        name: "",
        description: "",
        color: "#FFFFFF",
        type: "",
        pages: [],
        tokens: "",
        elearning_course_id: "0",
        home_page_id: "0",
        redirect_config: {
          elearning: {
            type: "normally-page", // elearning-courso,
            target: "same",
            logout_redirect: "0",
          },
        },
      };

      this.$refs.restrictArea.close();
    },

    updateRestrictArea() {
      editRestrictArea(this.restrictArea)
        .then((response) => {
          if (response.data.success) {
            this.$snotify.success(this.$t("ct-success-true"), {
              position: "centerTop",
            });

            this.fetchRestrictArea();
            this.cancelRestrictArea();
          } else {
            if (response.data.validator)
              this.errors.record({ restrictArea: response.data.errors });
            else {
              this.$snotify.error(this.$t("ct-success-false"), {
                position: "centerTop",
              });
            }
          }
        })
        .catch((error) => {
          this.$snotify.success(this.$t("ct-success-false"), {
            position: "centerTop",
          });
          this.cancelRestrictArea();
        })
        .finally(() => {
          this.$loading.hide();
        });
    },

    createRestrictArea() {
      this.$loading.show();

      createRestrictArea(this.restrictArea)
        .then((response) => {
          if (response.data.success) {
            this.$snotify.success(this.$t("ct-success-true"), {
              position: "centerTop",
            });

            this.fetchRestrictArea();
            this.cancelRestrictArea();
          } else {
            if (response.data.validator)
              this.errors.record({ restrictArea: response.data.errors });
            else {
              this.$snotify.error(this.$t("ct-success-false"), {
                position: "centerTop",
              });
            }
          }
        })
        .catch((error) => {
          this.$snotify.error(this.$t("ct-success-false"), {
            position: "centerTop",
          });
          this.cancelRestrictArea();
        })
        .finally(() => {
          this.$loading.hide();
        });
    },

    goToWebsitePage(page) {
      let user = this.getUser();

      if (typeof this.website.url !== null) {
        if (
          typeof this.website.dominio !== null &&
          this.website.dominio !== "" &&
          this.website.dominio !== null
        ) {
          window.open(
            "https://" + this.website.dominio + "/" + page.url,
            "_blank"
          );
        } else {
          if (user.user_editor) {
            let subdominio = user.user_editor.subdominio.replace("_", "-");
            var dominio = typeof process.env.PREMIUN_DOMAIN !== 'undefined' ? process.env.PREMIUN_DOMAIN : '.site.builderallsite.com';

            if (user.is_free == "1")
              dominio = typeof process.env.FREE_DOMAIN !== 'undefined' ? process.env.FREE_DOMAIN : '.free.builderallsite.com';


            window.open(
              "https://" +
              subdominio +
              "-" +
              this.website.url +
              dominio +
              "/" +
              page.url,
              "_blank"
            );
          }
        }
      }
    },

    openSettingsPage(page) {
      this.$router.push({
        name: "SitePageEdit",
        params: { page_id: page.encrypted_id },
      });
    },

    duplicatePageData(page) {
      this.$loading.show();

      duplicatePage(page)
        .then((res) => {
          if (res.data.success) {
            this.updateData();
            this.$snotify.success(this.$t("ct-page-duplicated"));
          } else
            this.$snotify.error(res.data.error);

        })
        .finally(() => this.$loading.show());
    },

    async updateData() {
      this.$loading.show();

      await getWebsite(this.website.encrypted_id)
        .then((data) => {
          this.$store.commit("website", data.data);
        })
        .catch((error) => console.warn(error))
        .finally(() => this.$loading.hide());
    },

    uploadImagePage(page) {
      this.imagePage.show = true;
      this.imagePage.page = page;

      let values = {
        action: "open",
        type: "Images",
        save: this.saveImagePage,
        close: this.closeUploadPage,
      };

      this.$root.$emit("fileMananger", values);
    },

    saveImagePage(image) {
      let configuration = {
        og_image: image
      };

      if (this.imagePage.page.configuration) {
        this.imagePage.page.configuration.og_image = image;
      } else
        this.imagePage.page = { ...this.imagePage.page, configuration };


      var vm = this;

      this.$loading.show();

      editConfigurationPage(this.imagePage.page)
        .then((response) => {
          vm.website.layouts[0].pages.map((page, index) => {
            if (page.id === response.data.id) {
              vm.website.layouts[0].pages[index].configuration =
                response.data.configuration;
            }
          });
          this.pagesFiltered = this.filterPages();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => this.$loading.hide());

      this.closeUploadPage();
    },

    closeUploadPage() {
      let values = {
        action: "close",
        type: "Images",
        save: this.saveImagePage,
        close: this.closeUploadPage,
      };

      this.$root.$emit("fileMananger", values);

      this.imagePage = {
        show: false,
        page: "",
      };
    },

    cancelModal(type) {
      this.modalDelete[type].show = false;
      this.modalDelete[type].config = "";
    },

    confirmDelete(type, config) {
      this.modalDelete[type].text = this.$t(`ct-confirm-delete-${type}`);
      this.modalDelete[type].show = true;
      this.modalDelete[type].config = config;

      if (type === "page") {
        if (config.is_blog) {
          this.modalDelete[type].text = this.$t("ct-blog-page-not-authorized");
          this.modalDelete[type].config.hideConfirm = true;
        }
      }
    },

    deletePage(page) {
      if (!page.initial) {
        excludePage(page)
          .then((data) => {
            this.cancelModal("page");
            this.$store.commit("website", false);
          })
          .catch((error) => console.warn(error));
      } else {
        this.$snotify.error(this.$t("ct-home-dont-delete"), { timeout: 6000 });
        this.cancelModal("page");
      }
    },

    // newPage(website) {
    //   if (this.$route.name !== "SitePageCreate") {
    //     this.$router.push({
    //       name: "SitePageCreate",
    //       params: { layout_id: website.layouts[0].encrypted_id },
    //     });
    //   }
    // },

    newPageTurbo() {
      this.$router.push({
        name: "CheetahTurboPage",
        params: { id: this.websiteCurrent.encrypted_id },
      });
    },

    newPageMembers() {
      this.$refs.restrictAreaAddPage.open();
    },

    saveNewPageMembers() {
      this.$loading.show();

      createMembers({
        id: this.website.id,
        encrypt_id: this.website.encrypted_id,
        layout_encrypt_id: this.website.layouts[0].encrypted_id,
      })
        .then((res) => {
          if (res.data.success)
            this.updateData();

        })
        .finally(() => {
          this.$refs.restrictAreaAddPage.close();
          this.$loading.hide();
        })
        .catch((error) => console.error(error));
    },

    filterPages() {
      if (
        Object.keys(this.website).length === 0 ||
        !this.website.layouts.length
      )
        return;


      let pages = [...this.website.layouts[0].pages];

      if (this.filters.restrict) {
        let restricted = this.filters.restrict;

        if (restricted.name) {
          pages = pages.filter(function (page) {
            let hasRestrict = page.restrict_areas.filter((restrict) => {
              return restrict.name === restricted.name;
            });

            return page.restrict_areas.length > 0 && hasRestrict.length > 0;
          });
        }
      }

      if (this.filters.search) {
        let search = this.filters.search;

        pages = pages.filter(function (page) {
          return (
            page.name.indexOf(search) > -1 || page.url.indexOf(search) > -1
          );
        });
      }

      return pages;
    },

    async filterRestrictArea(restrict = "") {
      if (restrict && restrict !== "all-restrict-empty")
        this.filters.restrict = restrict;
      else if (restrict === "all-restrict-empty")
        this.filters.restrict = { name: false };

      let pagesFiltered = await this.filterPages();
      this.pagesFiltered = pagesFiltered;
    },

    updateFormatRestrictPage() {
      this.restrictAreasFormat = this.getFormatRestrictPage();
    },

    getFormatRestrictPage() {
      let restritctArea = [...this.restrictAreas];
      let pages = this.website.layouts
        ? [...this.website.layouts[0].pages]
        : [];

      restritctArea.map((restricted) => {
        restricted.pages = [];
        restricted.pagesObj = pages.filter(function (page) {
          let hasRestrict = page.restrict_areas.filter((restrict) => {
            if (restrict.name === restricted.name)
              restricted.pages.push(page.id);

            return restrict.name === restricted.name;
          });

          return page.restrict_areas.length > 0 && hasRestrict.length > 0;
        });
      });

      return restritctArea;
    },

    changeViewRestrict() {
      if (this.viewRestrict === "inline") {
        this.viewRestrict = "block";
        this.setViewRestrict("block");
      } else {
        this.viewRestrict = "inline";
        this.setViewRestrict("inline");
      }
    },

    setViewRestrict(value) {
      localStorage.setItem("restrict-view-type", value);
    },

    getViewRestrict() {
      let viewType = localStorage.getItem("restrict-view-type");

      if (!viewType) {
        localStorage.setItem("restrict-view-type", "inline");

        return "inline";
      }

      return viewType;
    },

    addNewToken() {
      this.$refs["restrictArea-tokens"].close();
      this.$refs["restrictArea-token-add"].open();
    },

    copyToken(index) {
      try {
        let toCopy = document.querySelector("#copy-token-" + index);
        toCopy.setAttribute("type", "text");
        toCopy.select();
        this.copy_success = !!document.execCommand("copy");
        toCopy.setAttribute("type", "hidden");
        window.getSelection().removeAllRanges();

        setTimeout(() => {
          this.copy_success = false;
        }, 1500);
      } catch (err) {
        this.copy_success = false;
      }
    },

    editToken(token) {
      Object.keys(token).forEach(
        (key) => token[key] == null && delete token[key]
      );
      this.newToken = { ...this.newToken, ...token };
      this.newToken.action = "edit";
      if (!token.expires_at)
        this.newToken.has_expires_at = 0;
      else this.newToken.has_expires_at = 1;
      this.$refs["restrictArea-token-add"].open();
    },

    deleteToken(token, index) {
      this.restrictArea.tokens.splice(index, 1);
    },

    clearFilters() {
      this.filters = {
        restrict: {},
        search: "",
      };
    },

    fetchRestrictTypes() {
      getRestrictAreaTypes()
        .then(({ data }) => {
          if (data.success)
            this.restrictAreaTypes = data.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
        });
    },

    fetchElearning() {
      this.loading.elearning = true;

      getElearningCourses()
        .then(({ data }) => {
          if (data.success)
            this.elearningCourses = data.data;

        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading.elearning = false));
    },

    fetchMailingbossList() {
      this.loading.mailingboss = true;

      getLists()
        .then(({ data }) => {
          if (data.success)
            this.mailingboss_lists = data.data;

        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading.mailingboss = false));
    },

    async fetchDataModal() {
      this.fetchRestrictTypes();
      this.fetchMailingbossList();
      this.fetchElearning();
    },

    async fetchData() {
      let websiteId = this.$route.params.id;

      if (!websiteId)
        return;


      this.$loading.show();

      await Promise.all([
        getAllRestrictArea(websiteId)
      ])
        .then(([allRestrictAreas, typesRestrictArea]) => {
          if (allRestrictAreas.data.success)
            this.restrictAreas = allRestrictAreas.data.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => this.$loading.hide());
    },

    async fetchRestrictArea() {
      let websiteId = this.$route.params.id;

      if (!websiteId)
        return;


      this.updateData();

      this.$loading.show();

      await getAllRestrictArea(websiteId)
        .then((res) => {
          if (res.data.success)
            this.restrictAreas = res.data.data;

        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => this.$loading.hide());

      this.updateFormatRestrictPage();
      this.filterRestrictArea();
    },
  },

  async created() {
    this.filters.search = "";
    this.viewRestrict = this.getViewRestrict();

    this.setWebsite(this.$store.getters.website);
    await this.fetchData();
    this.updateFormatRestrictPage();
    this.filterRestrictArea();
    this.typeViewLoad();

    window.vm.$Progress.finish();
  },
};
</script>

<style lang="scss" scoped>

#color{
    border-radius: 50%;
    height: 30px;
    width: 30px;
    border: none;
    outline: none;
    -webkit-appearance: none;
}

#color::-webkit-color-swatch-wrapper {
    padding: 0;
}
#color::-webkit-color-swatch {
    border: none;
    border-radius: 50%;
}

.text-restrict-form {
  font-size: 16px;
  color: #434343;
  margin: 10px 0;
  display: inline-block;
}

.container {
  @media (min-width: 1200px) {
    max-width: 1160px;
  }
}

.container-box {
  width: 100%;

  display: grid;

  grid-template-columns: 1fr;
  row-gap: 15px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    row-gap: 25px;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 25px;
    row-gap: 30px;
  }

  .box {
    margin: 0;
  }
}

.restrict-area-container-block .restrict-area-container-block-list-pages,
.blog-container-block .blog-block-list-pages {
  display: grid;
}

.box:not(.new-page) {
  .box-info {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}

.box-icon-left-sm {
  width: 25px;
  height: 25px;
  background-color: #000000;
}

.box-icon-left {
  width: 35px;
  height: 35px;
  background-color: #0080fc;
}

.builder-action-multiple-websites_checkbox-all-label{
  margin-bottom: 0;
}

.box-restrict-header {
    background: #fff;
    border: 1px solid #e4eaf6;
    border-radius: 16px;
    -webkit-box-shadow: 0 0 2px 0 rgba(136, 152, 170, 0.14902);
    box-shadow: 0 0 2px 0 rgba(136, 152, 170, 0.14902);
    width: 100%;
    height: auto;
    padding: 16px;
    margin-bottom: 16px;
    min-height: 95px;
    display: flex;
    align-items: center;

    .box-restrict-image-container {
        width: 180px;
        height: 80px;
        border-radius: 16px;
        margin: 0 8px;
        cursor: pointer;
        background-size: cover;
    }

    .title-principal {
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        color: #1E1E2D;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        max-width: 100%;
        transition: all 0.3s;
        height: 26px;
        line-height: 25.6px;
        max-width: 280px;

        &:hover {
          color: #0072E1;
        }
      }

  @media (max-width: 680px) {
    width: 100%;
    display: block;
    height: auto;

    div:last-child {
      text-align: center;
      width: 100%;
      margin: 5px 0;
    }
  }
}

.box-icon-left,
.box-icon-left-sm {
  display: inline-flex;
  font-size: 19px;
  color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  // margin-right: 10px;

  .svg-inline--fa {
    vertical-align: 0;
  }
}

.new-page {
  min-height: 259px;
  border-radius: 16px;

  &.box {
    background: #f8fafd;
    border: 1px dashed #05c1fc;
    cursor: pointer;
  }

  &.new-page-members.box {
    background: #f8fafd;
    border: 1px dashed #644588;
    cursor: pointer;

    .box-info {

      .icon,
      .btn-primary-light {
        color: #644588;
      }
    }
  }

  &.container-box {
    margin: 0;
    padding: 0;
  }

  .box-info {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}

.box-display-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.dropdown-menu {
  box-shadow: 0px 0px 5px #26242459;
}

.dropdown-container .dropdown-menu {
  border-radius: 0 0 10px 10px;
  top: -5px !important;
  min-width: 133px;
  box-shadow: 0px 2px 2px #2624241a;
}

.card-restrict {
  background: #FFFFFF;
  border: 1px solid #E4EAF6;
  border-radius: 16px;
  box-shadow: 0 0 2px 0 #8898aa26;
  height: auto;

  @media (max-width: 576px) {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
  }

  .card-restrict-body {
    width: 100%;
    height: 127px;

    .card-body-image-container {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: 50%;
      background-repeat: no-repeat;
      border-radius: 16px 16px 0 0;
    }
  }

  .card-restrict-footer {
    width: 100%;
    min-height: 130px;
    height: auto;
    background: #ffffff;
    opacity: 1;
    padding: 16px 20px;
    border-radius: 0 0 16px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .box-info {
      display: flex;
      flex-direction: column;
      text-align: left;

      .title-principal {
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        color: #1E1E2D;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        max-width: 100%;
        transition: all 0.3s;
        height: 26px;
        line-height: 25.6px;
        max-width: 280px;

        &:hover {
          color: #0072E1;
        }
      }
    }

    .box-options {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: end;
      -webkit-box-align: end;
      -ms-flex-align: end;
      align-items: end;
      width: 100%;
    }

  }



}

.title-modal-member {
  color: #434343;
  font-size: 20px;
  font-weight: bold;
}

.title-member-area {
  color: rgb(67, 67, 67);
  font-size: 22px;
  font-weight: bold;
  flex: 1;
}

.obs-member-area {
  cursor: pointer;
  flex: 1;
  text-align: right;
  color: #0080fc;
  font-weight: bold;
  text-transform: uppercase;
}

.alert-member-area {
  color: #434343;
  font-size: 16px;
  margin: 15px 0;
}

.dropdown-item.dropdown-last {
  background-color: #007bff;
  color: #fff;

  .span {
    margin-left: 3px;
  }

  svg {
    vertical-align: middle;
    margin: 0 2px;
  }
}

.dropdown-toggle.btn-filter {
  position: relative;
  padding: 0.375rem 1rem;
  text-align: left;
  min-width: 170px;

  &::after {
    position: absolute;
    margin: 0.56em;
    right: 0;
    display: none;
  }
}

.btn-filter {
  min-width: 130px;
  height: 40px;
  font-weight: bold;
  color: #434343;
  border-radius: 5px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0.62px 0.79px 2px #1e120d1a;
}

.sort-icon {
  color: #c6c2c2;
  height: 15px;
  width: 10px !important;
  margin-left: 8px;
  margin-right: unset !important;
}

.new-page .btn:hover {
  color: #0056b3;
}

.box-filter {

  & .form-inline .form-control {
    max-width: 200px;
    min-width: 200px;
  }

  &.type-search .form-inline {
    min-width: 200px;
    max-width: 200px;
    display: flex;
    align-items: center;
    vertical-align: middle;
    justify-content: end;
    position: absolute;

    .btn-search {
      left: 0;

      &:focus {
        box-shadow: none;
      }
    }

    .btn-clear {
      margin-left: -30px;
      padding: 0;
      color: #c6c2c2;

      &:focus {
        box-shadow: none;
      }

      &:hover {
        color: #000;
      }
    }

    input {
      background-color: transparent;
      border-radius: 0;
      border: none;
      border-bottom: 1px solid #c6c2c2;
      padding-left: 30px;

      &:focus {
        box-shadow: none;
        border-bottom: 2px solid #0294ff !important;
      }
    }
  }
}

.vrow {
  float: left;
  border-left: 1px solid #c6c2c2;
  height: 15px;
  margin: 0 15px;
}

.btn-members-area {
  min-height: 38px;
  padding: 6px 20px;
  min-width: 100px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.options {
  .font-awesome-icon {
    color: #868282;

    &:hover {
      color: #5a5959;
    }
  }
}

.selected-color {
  border-radius: 100%;
  display: block;
  width: 25px;
  height: 25px;
  cursor: pointer;
  border: 1px solid #ccc;
}

.sweet-modal {
  section {
    font-family: "Muli", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;

    h1 {
      font-weight: bold;
      font-size: 20px;
      color: #434343;
    }

    h2 {
      color: #5a5959;
      font-size: 18px;
    }

    p {
      font-size: 17px;
      color: #5a5959;

      span:first-child {
        font-weight: bold;
      }
    }
  }
}

.choose-view {
  div {
    color: #C4D1E0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    cursor: pointer;

    &.selected {
      color: #0080FC;
    }
  }

  // i[class^="ct-icon-"] {
  //   font-size: 24px;
  //   margin-left: 12px;
  //   cursor: pointer;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/views/WebsiteHome.vue